import Cookies from "js-cookie"

// Sync with Consent Initialization configs in GTM
const consentRegions = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "GB",
  "CH",
]

export const getStoredConsent = () => {
  const consentCookie = Cookies.get("gtm_consent")

  if (consentCookie) {
    try {
      return JSON.parse(consentCookie)
    } catch (e) {
      console.log("Unable to parse `gtm_consent` cookie")
    }
  }

  return null
}

export const isConsentRequired = () => {
  const geoCookie = Cookies.get("geo")
  return geoCookie && consentRegions.includes(geoCookie)
}

export const getConsentState = () => {
  const storedConsent = getStoredConsent()
  const consentRequired = isConsentRequired()

  if (storedConsent) {
    return storedConsent
  }

  if (typeof window !== "undefined" && window.gtmConsentState) {
    return window.gtmConsentState
  }

  return {
    ad_storage: consentRequired ? "denied" : "granted",
    analytics_storage: consentRequired ? "denied" : "granted",
  }
}
